import { ValueApi } from '../../api/models/historical';

class BaseValue
{
    channel: string;
    channelId: number;

    constructor (valApi: ValueApi)
    {
        this.channel = valApi.channel;
        this.channelId = valApi.channelId;
    }
}

export class Value extends BaseValue
{
    unit: string;
    value: string;

    constructor (valApi: ValueApi)
    {
        super(valApi);

        if (valApi !== null && valApi.value !== null)
        {
            this.value = valApi.value.trim();
            this.unit = this.value.substring(this.value.lastIndexOf(' ')).trim();
        }
        else
        {
            this.value = null;
            this.unit = '';
        }
    }
}

export class RawValue extends BaseValue
{
    rawValue: number;

    constructor (valApi: ValueApi)
    {
        super(valApi);

        this.rawValue = valApi.value !== null ? parseFloat(valApi.value) : null;
    }
}
